import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DataService } from 'app/data.service';
import { environment } from 'environments/environment';

export const passwordMatchValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
  const password1 = control.get('newPassword1');
  const password2 = control.get('newPassword2');

  return password1 && password2 && password1.value != password2.value ? { 'passwordMatch': true } : null
}

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  userProfile: any
  
  dataLoaded: boolean

  selectedImage: any

  image: any

  passwordGroup: FormGroup

  userProfileForm: FormGroup = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required]),
    dob: new FormControl('', [Validators.required])
  })

  constructor( private _neproseService: DataService, private _notification: MatSnackBar ) { }

  ngOnInit(): void {
    this.getProfile()
    this.passwordGroup  = new FormGroup({
      'oldPassword': new FormControl('', [Validators.required, Validators.minLength(8)]),
      'newPassword1': new FormControl('', [Validators.required, Validators.minLength(8)]),
      'newPassword2': new FormControl('', [Validators.required]),
    }, { validators: passwordMatchValidator })
  }

  getProfile(){
    this._neproseService.getProfile().subscribe(data => {
      this.dataLoaded = true
      if(data.status){
        this.userProfile = data.user
        if(this.userProfile.profileImage){
          this.selectedImage = environment.api + '/images/' + this.userProfile.profileImage
        }
        this.userProfileForm.setValue({firstName: this.userProfile.firstName, lastName: this.userProfile.lastName, email: this.userProfile.Credential.email, dob: this.userProfile.dob})
      }
    })
  }

  fileChangeEvent(event: any): void {
    this.image = event.target.files[0]
    if(this.image){
      var filesize = Math.ceil((parseInt(this.image.size)/1024)/1024)
      if(filesize <= 8){
        this._neproseService.updateProfileImage(this.image).subscribe(data => {
          if(data.status){
            var reader = new FileReader();
            reader.readAsDataURL(event.target.files[0]); 
            reader.onload = (_event) => { 
              this.selectedImage = reader.result; 
            }
            this.openNotification('Profile image has been uodated!')
          }
        })
      }else{
        this.openNotification('File size exceeded! Maximum size is 2MB.')
      }
    }
  }

  updateUser(user){
    this._neproseService.updateUser(user).subscribe(data => {
      if(data.status){
        this.getProfile()
        this.openNotification('Profile has been updated!')
      }
    })
  }

  onFormSubmit(form){  
    this._neproseService.changePassword(form.newPassword1, form.oldPassword).subscribe(data => {
      if(data.status){
        Object.keys(this.passwordGroup.controls).forEach(key => {
          this.passwordGroup.get(key).setErrors(null) ;
        });
        this.openNotification('Password has been changed!')
      }
    }, error => {
      if(error.error){
        this.openNotification(error.error.message)
      }
    })
  } 

  openNotification(msg){
    this._notification.open(msg, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

}
